/**
 * Factory for creating web component classes.
 *
 * ClojureScript cannot directly create `class extends HTMLElement` (which
 * browsers require for custom elements). This tiny JS module provides a
 * factory that returns such a class with callback hooks that CLJS can set
 * on the prototype.
 *
 * Hooks (set on prototype by CLJS after class creation):
 *   _onConnect()          - called in connectedCallback
 *   _onDisconnect()       - called in disconnectedCallback
 *   _onAttrChange(n,o,v)  - called in attributeChangedCallback
 */
export function createComponent(observedAttrs) {
  return class extends HTMLElement {
    static get observedAttributes() { return observedAttrs; }

    constructor() {
      super();
      this.attachShadow({ mode: 'open' });
      this._connected = false;
    }

    connectedCallback() {
      this._connected = true;
      if (this._onConnect) this._onConnect.call(this);
    }

    disconnectedCallback() {
      this._connected = false;
      if (this._onDisconnect) this._onDisconnect.call(this);
    }

    attributeChangedCallback(name, oldVal, newVal) {
      if (this._connected && oldVal !== newVal && this._onAttrChange) {
        this._onAttrChange.call(this, name, oldVal, newVal);
      }
    }
  };
}
